import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { Header } from "components";
import { Bathroom } from "pages";

const Bedroom = lazy(() => import("pages/Bedroom"));

const App = () => {
    return (
        <>
            <Header />
            <main className="main">
                <Suspense fallback={null}>
                    <Routes>
                        <Route path="/glb_scene/three/bathroom" element={<Bathroom />} />
                        <Route path="/glb_scene/three/bedroom" element={<Bedroom />} />
                    </Routes>
                </Suspense>
            </main>
        </>
    );
};

export default App;
